import { Text as BaseText } from "@chakra-ui/react";

export default BaseText;
